import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsDrawerLayout',
  props: {
  showFooter: {
    type: Boolean,
    default: false,
  },
  showLoadingOverylay: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const { showFooter, showLoadingOverylay } = toRefs(props);

return { __sfc: true,props, showFooter, showLoadingOverylay }
}

})